import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { State } from '../../types';

export type StopRecordingPerformanceExperiences = () => void;

export const stopRecordingPerformanceExperiences =
	() =>
	({ setState }: StoreActionApi<State>): StopRecordingPerformanceExperiences =>
	() => {
		setState({
			shouldRecordPerformanceExperiences: false,
		});
	};
